import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  messageCount: 0,
};

const messageSlice = createSlice({
  name: "message",
  initialState,
  reducers: {
    setCount: (state, action) => {
      state.messageCount = action?.payload;
    },
  },
});

export const { setCount } = messageSlice?.actions;
export default messageSlice?.reducer;
